import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import TpClientLinkService from '../../../Services/tpClientLinkService';
import LinkTpClientToClientData from '../../Sales/ClientAdmin/LinkTpClientToClientData';

export default class TpClientLinkLinkToClientWindowDescription extends React.Component {
  static titleForCreate = 'Link Third-Party Client to Bravo Client';
  static titleForEdit = 'Link Third-Party Client to Bravo Client';
  static ComponentName = 'Client';
  static itemType = LinkTpClientToClientData;
  static serviceFunction = (edited) => TpClientLinkService.LinkTpClient(edited);
  static errorHandler = (error, edited) => {
    if (error.includes('Client name does not match.')) {
      edited.ApprovationNeeded = true;
    }
  };

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'ThirdPartySource',
          label: 'Third-Party Source',
          className: 'col-12',
          type: InputTypesEnum.ThirdPartySourceTpClientLinkSelect,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'ThirdPartyClientId',
          label: 'Third-Party Client Id',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'NameDifferenceApproved',
          label: 'Name difference is approved',
          className: 'col-12',
          type: InputTypesEnum.Checkbox,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (edited) => !edited.ApprovationNeeded,
        },
      ],
    },
  ];
}
